import React, { useState, useEffect } from 'react';
import '../Assets/css/loader.css';
import HourglassLoader from './HourGlass/HourglassLoader';

function LoaderCustom({ text }) {
  const jokes = [
    "Annual performance review: 11 months of ignoring you, 1 month of judging you.",
    "Team-building exercise: pretending to enjoy being outside with coworkers.",
    "Email chains: the art of saying nothing, with everyone copied.",
    "Company newsletter: news nobody asked for, about people you don’t know.",
    "Action items: things to forget by next week.",
    "Our open-door policy means we’ll ignore you with the door open.",
    "Deadline: the thing we set, miss, and then quietly extend.",
    "Conference call: where someone always forgets they’re on mute.",
    "KPIs: keeping people insecure.",
    "Work anniversary email: a reminder you’re still here.",
    "All-hands meeting: all hands… still doing the same thing after.",
    "Lunch break: 30 minutes to eat, 20 minutes to answer emails.",
    "Overtime: because we mismanaged time during regular time.",
    "Budget meeting: the sport of creative subtraction.",
    "Onboarding: here’s 50 PDFs you’ll never read.",
    "Strategic planning: guessing what might go wrong, then ignoring it.",
    "Brainstorm session: the loudest idea wins, not the best.",
    "Remote work check-in: proving you’re online while folding laundry.",
    "Meeting notes: the graveyard of follow-ups.",
    "Corporate ladder: more like a corporate escalator that’s out of order.",
    "Casual Friday: the same stress, slightly softer pants.",
    "Office gossip: faster than email, less accurate than reports.",
    "Workflow optimization: renaming problems without solving them.",
    "Quarterly budget review: crying with spreadsheets open.",
    "Manager’s feedback: vague enough to be useless, specific enough to hurt.",
    "Corporate happy hour: smiling through small talk.",
    "Project kickoff: excitement before reality sets in.",
    "Job descriptions: 3 bullet points that somehow become 12 responsibilities.",
    "Internal survey: where honesty goes to die.",
    "Restructuring: rearranging the deck chairs on the Titanic.",
    "Our meetings could be an email… but then how would we waste time?",
    "Teamwork makes the dream work… until someone takes credit for your work.",
    "Please reply-all wisely… or unleash chaos.",
    "Coffee: because corporate life is a marathon you didn’t sign up for.",
    "My brain has too many tabs open… and one is playing music I can’t find.",
    "Corporate life: 90% meetings, 10% pretending to work.",
    "Deadline? More like dead inside.",
    "‘Let’s circle back’ = I have no idea what I’m doing.",
    "Your KPI is surviving this week without crying in the restroom.",
    "‘Synergy’ – the art of saying nothing with enthusiasm.",
    "Work smarter, not harder… but somehow do both and stay late.",
    "Zoom call: where productivity goes to die.",
    "Action items: a to-do list for things we’ll never do.",
    "Corporate ladder = broken escalator… but HR says keep climbing.",
    "Email sent at 11:59pm: ‘Look at me, I’m a work hero.’",
    "Job title inflation: ‘Intern’ is now ‘Junior Executive Solutions Associate.’",
    "Quarterly review: let’s make up reasons why we missed targets.",
    "‘Touch base’ = talk about nothing for 30 minutes.",
    "Corporate bingo: synergy, pivot, bandwidth, leverage.",
    "Nothing says productivity like a meeting about the next meeting.",
    "HR training video: proof that comedy is dead.",
    "PowerPoint: where ideas go to get bullet points.",
    "Office birthday cake: the only reason anyone comes in.",
    "Micromanagement: because trust is overrated.",
    "Company values poster: the biggest lie on the wall.",
    "Promotions are like UFOs – people claim they’ve seen them, but no proof.",
    "We value work-life balance… as long as work is your life.",
    "Raises are like Bigfoot – everyone talks about them, no one gets one.",
    "Budget cuts: now you do three jobs for the same pay.",
    "Office coffee: because we ran out of ways to be disappointed."
  ];

  const [currentJoke, setCurrentJoke] = useState(jokes[0]);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomJoke = jokes[Math.floor(Math.random() * jokes.length)];
      setCurrentJoke(randomJoke);
    }, 5000); // change every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div align="center" className="row">
      <div className="col-md-12 col-sm-12 col-xs-12">
        {/* Hourglass Loader */}
        <HourglassLoader />
        <h1 className="loadertitle" style={{ color: 'black' }}>{text}</h1>
        {/* Joke Box */}
        <p
          className="p-3"
          style={{
            color: 'black',
            fontSize: '1.1rem',
            marginTop: '20px',
            border: '2px solid #e59400',
            width: 'fit-content',
            padding: '10px',
            borderRadius: '8px',
            background: '#fff8e7'
          }}
        >
          {currentJoke}
        </p>
      </div>
    </div>
  );
}

export default LoaderCustom;
